import { render } from "./expensesreport.vue?vue&type=template&id=a528170a&scoped=true"
import script from "./expensesreport.vue?vue&type=script&lang=js"
export * from "./expensesreport.vue?vue&type=script&lang=js"

import "./expensesreport.vue?vue&type=style&index=0&id=a528170a&lang=css"
import "./expensesreport.vue?vue&type=style&index=1&id=a528170a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a528170a"]])

export default __exports__